import { i18nConfig } from 'airkey-mfa-react';

const es = {
  translation: {
    ...i18nConfig.resources.es.translation,
    introBottomSheetHeaderLabel: 'Toque su tarjeta Airkey para verificar',
  },
};

export default es;
